export const directBookingsSettingsView = {
  loading: "Carregando configurações…",

  sidebar: {
    brandTitle: "Anúncios",
    brandSub: "Painel de configurações",
    searchPlaceholder: "Buscar…",
    generalLabel: "Geral",
    servicesName: "Serviços e experiências",
    servicesSub: "Uma lista para toda a conta",
    promotionsName: "Promoções",
    promotionsSub: "Criar · Editar · Gerenciar",
    globalChip: "GLOBAL",
    inactivePrefix: "Inativo · {type}",
    unitsCount: "{count} unidade | {count} unidades",
    empty: "Nenhuma propriedade.",
    listingFallbackName: "Anúncio",
  },

  status: {
    active: "Ativo",
    inactive: "Inativo",
  },

  card: {
    unsavedChanges: "Alterações não salvas",
  },

  share: {
    title: "Link de reserva direta",
    hintPrefix: "Compartilhe o link de",
    hintSuffix: "para receber reservas sem comissão.",
    copyTitle: "Copiar link",
    viewAsVisitor: "Ver como visitante",
    copied: "Link copiado.",
    copyError: "Não foi possível copiar o link.",
    whatsappText: "Olá 👋 Aqui está o link para reservar: {link}",
  },

  savebar: {
    unsaved: "Alterações não salvas",
    noChanges: "Nenhuma alteração pendente",
    saving: "Salvando…",
  },

  drawer: {
    close: "Fechar",
  },

  content: {
    selectListing: "Selecione um anúncio",
  },

  units: {
    pickerHint: "Ative ou desative a visibilidade de cada unidade para reservas diretas, ou abra-a para configurá-la (tarifas, imagens, descrição, serviços e cobranças).",
    visible: "Visível",
    hidden: "Oculta",
    showTooltip: "Mostrar esta unidade nas reservas diretas",
    configure: "Configurar",
  },

  header: {
    listingSub: "Anúncio · {count} unidade · reservas diretas | Anúncio · {count} unidades · reservas diretas",
    unitSub: "Unidade · configuração individual",
    unitSubCoded: "Unidade {code} · configuração individual",
    hotelSub: "Hotel / Camping · reservas diretas",
    apartmentSub: "Apartamento / Villa · reservas diretas",
  },

  tabs: {
    reservations:       { label: "Visibilidade do anúncio",  sub: "Ative e defina pagamento e aprovação para reservas diretas" },
    units_list:         { label: "Unidades",               sub: "Quais unidades podem ser reservadas" },
    common_images:      { label: "Áreas comuns",        sub: "Fotos compartilhadas do prédio (capa)" },
    rate_plans:         { label: "Tarifas",         sub: "Planos de tarifa visíveis" },
    images:             { label: "Imagens",              sub: "Galeria do anúncio" },
    description:        { label: "Descrição",          sub: "Texto e detalhes do anúncio" },
    services:           { label: "Serviços",            sub: "Serviços e comodidades" },
    promotions:         { label: "Promoções",          sub: "Como aparecem neste anúncio" },
    addons:             { label: "Ocupação",           sub: "Descontos e hóspede extra" },
    age_rules:          { label: "Regras de hóspedes",         sub: "Bebês, crianças e capacidade" },
    additional_charges: { label: "Cobranças e impostos",   sub: "IVA, limpeza e cobranças" },
    web_embed:          { label: "Integração web",     sub: "Adicione a caixa de busca ao seu próprio site" },
  },

  save: {
    ratePlans: "Salvar tarifas",
    promotions: "Salvar promoções",
    addons: "Salvar cobranças",
    ageRules: "Salvar regras",
    additionalCharges: "Salvar cobranças e impostos",
    payments: "Salvar pagamentos",
    default: "Salvar",
  },

  types: {
    apartment: "Apartamento",
    house: "Casa",
    villa: "Villa",
    loft: "Loft",
    room: "Quarto",
    studio: "Estúdio",
    cabin: "Cabana",
    hotel: "Hotel",
    hostel: "Hostel",
    camping: "Camping",
  },

  toasts: {
    unitVisible: "Unidade visível nas reservas diretas.",
    unitHidden: "Unidade oculta.",
    unitUpdateError: "Não foi possível atualizar a unidade.",
  },

  errors: {
    noUserUuid: "UUID do usuário não encontrado.",
    loadPage: "Não foi possível carregar a página.",
    loadContext: "Não foi possível carregar o contexto.",
    saveExec: "Não foi possível executar o salvamento.",
    saveGeneric: "Não foi possível salvar.",
  },

  misc: {
    propertyFallback: "Propriedade {id}",
  },
};
